"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityThumbnail = void 0;
var React = require("react");
var Thumbnail_1 = require("../Thumbnail");
var EntityThumbnail = function (_a) {
    var Src = _a.Src, _b = _a.Size, Size = _b === void 0 ? "Normal" : _b, Icon = _a.Icon, rest = __rest(_a, ["Src", "Size", "Icon"]);
    return React.createElement(React.Fragment, null,
        React.createElement(Thumbnail_1.Thumbnail, __assign({}, rest, { Size: Size, Shape: "Square", Src: Src, Placeholder: Icon })));
};
exports.EntityThumbnail = EntityThumbnail;
